import { FixedNationwidePricingContextProvider, FixedPricingContextProvider } from "@/components/organisms";
import { PricingProfilePanel } from "@/components/organisms/TripCost/FixedPricing/PricingProfilePanel";
import { Nationwide } from "./Nationwide";
import { PricingLocation } from "./PricingLocation";
import { PricingState } from "./PricingState";

export const PricingProfile = () => {
  return (
    <FixedPricingContextProvider>
      <FixedNationwidePricingContextProvider>
        <PricingProfilePanel />
      </FixedNationwidePricingContextProvider>
    </FixedPricingContextProvider>
  );
};

PricingProfile.Nationwide = Nationwide;
PricingProfile.PricingState = PricingState;
PricingProfile.PricingLocation = PricingLocation;
